import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { L10nTranslationService } from 'angular-l10n';
import { Observable, Subject } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { LoadingIndicatorModes, LoadingStateService } from './loading-state.service';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private successNotification: Subject<boolean> = new Subject();

  constructor(
    private dialog: MatDialog,
    private loadingStateService: LoadingStateService,
    public translationService: L10nTranslationService
  ) {}

  notifySuccess(value: boolean) {
    this.successNotification.next(value);
  }

  public getSuccessNotificationStatus() {
    return this.successNotification.asObservable();
  }

  openDialog<T = any>(dialogClassRef: any, data?: any, dialogOptions?: any): Observable<T extends any ? T : any> {
    dialogOptions = {
      position: { top: '0px' },
      minWidth: '40%',
      disableClose: false,
      panelClass: 'alert-modals',
      ...dialogOptions,
    };
    this.loadingStateService.setMode(LoadingIndicatorModes.Dialog);
    return this.dialog
      .open(dialogClassRef, { ...dialogOptions, data })
      .afterClosed()
      .pipe(
        take(1),
        finalize(() => this.loadingStateService.setMode(LoadingIndicatorModes.Full))
      );
  }
}
